
import store from '../store';
import { selectTopmenu, selectLeftmenu } from '../store/actions2';

const handleSubMenu = (menuObj: any, path: string) => {
    if (menuObj.path === path) {
        return menuObj
    } else {
        if (menuObj.subMenu) {
            for (let key in menuObj.subMenu) {
                const result: any = handleSubMenu(menuObj.subMenu[key], path)
                if (result !== null) {
                    return result;
                }
            }
        }
    }
    return null;// 返回null以处理未找到匹配项的情况
}

export default function setRouteState(pathname:string) {
    const menuData = store.getState().menuData
    // console.log('pathname:', pathname)
    // console.log(menuData.menuAll)

    let obj2: any = null
    for (let key in menuData.menuAll) {
        const obj1 = handleSubMenu(menuData.menuAll[key], pathname)
        if (obj1) {
            obj2 = {
                key: key,
                id: obj1.id
            }
            break;
        }
    }
    if (obj2) {
        // console.log(key + ':', obj1)
        store.dispatch(selectTopmenu(obj2.key));
        // store.dispatch(selectLeftmenu(obj2.id));
    }
}